import React, { Component } from 'react';

import { Image, Col, Form, Row, Container, Tabs, Tab, Button, Modal, Accordion, Card} from 'react-bootstrap';
import CelularTarjeta from '../../../img/NewPNG/wb-segunda-franja-spanish.svg'
import ManoCartera from '../../../img/NewPNG/SegundaFranja_Manomoneda.png'
import CelularTarjeta2 from '../../../img/NewPNG/wb-segunda-franja-english.svg'
import ManoCartera2 from '../../../img/NewPNG/SegundaFranja_Manomoneda2.png'
import Translate from '../../../../../translate'
import './index.css'

class PrincipalBanner extends Component {
  constructor(props) {
    super(props);
    this.state = {  }
  }

  render() {
    return (
      <div className='tarjetaSectionStructure section-container' id='tarjeta' style={{padding: 0}}>
        <div className='manoMonedaDiv'>
          <Image src={this.props.lan === 'es' ? ManoCartera : ManoCartera2} className='ManoMonedaStyle'/>
          <Image src={this.props.lan === 'es' ? CelularTarjeta : CelularTarjeta2} className='cardCelImg' />
        </div>
        <Container>
          <Row>
            <Col xl={4} lg={4} md={12}  sm={12}/>
            <Col xl={8} lg={8} md={12}  sm={12} className="LosEspaciosDiv">
              <div className="margin-wrapper-mobile" >
                <p className='tarjetaFuturo-title'>{Translate[this.props.lan].landing3.seccion3.titulo}</p>
                <p className='tarjetaFuturo-subtitle'>{Translate[this.props.lan].landing3.seccion3.subtitulo}</p>
                <Button className='main-button' onClick={()=>window.open('/register','_blank')}>{Translate[this.props.lan].landing3.seccion3.boton}</Button>
              </div>
              <Row style={{paddingTop:'1em', paddingBottom:'1em'}}>
                <Col md={6} >
                  <p className='tarjetaMiniTitulo' >{Translate[this.props.lan].landing3.seccion3.paga}</p>
                  <p className='tarjetaMiniSubTitulo' >{Translate[this.props.lan].landing3.seccion3.padaGesc}</p>
                </Col>
                <div md={12} className="divDivisor"/>
                <Col md={6} >
                  <p className='tarjetaMiniTitulo' >{Translate[this.props.lan].landing3.seccion3.retira}</p>
                  <p className='tarjetaMiniSubTitulo' >{Translate[this.props.lan].landing3.seccion3.retiraDesc}
                    <br/>{Translate[this.props.lan].landing3.seccion3.retiraDesc1}</p>
                </Col>
                <div md={12} className="divDivisor"/>
                <Col md={6} >
                  <p className='tarjetaMiniTitulo' >{Translate[this.props.lan].landing3.seccion3.acepta}</p>
                  <p className='tarjetaMiniSubTitulo' >{Translate[this.props.lan].landing3.seccion3.aceptaDesc}</p>
                </Col>
                <div md={12} className="divDivisor"/>
                <Col md={6} >
                  <p className='tarjetaMiniTitulo' >{Translate[this.props.lan].landing3.seccion3.seguridad}</p>
                  <p className='tarjetaMiniSubTitulo' >{Translate[this.props.lan].landing3.seccion3.seguridadDesc}</p>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default PrincipalBanner;
